// extracted by mini-css-extract-plugin
export var button = "ApplePayButton-module__button___jg3HS";
export var logo = "ApplePayButton-module__logo___rnvjO";
export var text = "ApplePayButton-module__text___vK0Ye";